import React, { useEffect, useMemo, useRef, useState } from 'react';
import BackBtn from '../../components/UI/BackBtn';
import Page from '../../components/_layout/Page';
import { useHistory, useParams } from 'react-router-dom';
import { Button, Col, Form, Row, Card, CloseButton } from 'react-bootstrap';
import './AddIndexComponent.less';
import Select from 'react-select';
import AsyncSelect from 'react-select/async';
import api from '../../api';
import YearSelect from '../../components/common/YearSelect';
import { years } from '../../helpers';
import useAPI from '../../hooks/useAPI';
import useToast from '../../hooks/useToast';
import { formatDate } from '../../helpers/table';
import moment from 'moment';
import { Close, Delete, History } from '@material-ui/icons';
import PersonsHistoryModal from '../../components/Indexes/PersonsHistoryModal';
import AttentionSaveFormulaModal from '../../components/Indexes/AttentionSaveFormulaModal';
import Required from '../../components/Required';
import { MonetaryFloatInput } from '../../components/common/MonetaryFloatInput';

const factKpisType = 'Данные для расчета фактических значений по показателям';
const selectStyles = {
  placeholder: (base) => ({
    ...base,
    fontSize: 16
  }),
  singleValue: (base) => ({
    ...base,
    fontSize: 16
  }),
  noOptionsMessage: (base) => ({
    ...base,
    fontSize: 16
  }),
  loadingMessage: (base) => ({
    ...base,
    fontSize: 16
  }),
  option: (base) => ({
    ...base,
    fontSize: 16
  }),
  input: (base) => ({
    ...base,
    fontSize: 16
  })
};
const unitsOptions = ['%', 'единица', 'рублей', 'тыс. руб.', 'тыс. руб./чел.', 'человек']
  .map(unit => ({
    label: unit,
    value: unit
  }));
const indexGroupOptions = [
  'Данные для расчета фактических значений по показателям',
  'Показатели, необходимые для достижения результата предоставления гранта',
  'Целевые показатели эффективности реализации программы развития университета, получающего базовую часть гранта',
  'Целевые показатели эффективности реализации программы развития университета, получающего специальную часть гранта'
].map(group => ({
  label: group,
  value: group
}));
const yearOptions = years.map(year => ({label: year, value: year}))
const defaultComponentData = {
  bosses: [],
  delegates: [],
  values: [],
  num: '',
  name: '',
  fullName: '',
  calcDescr: '',
};
const defaultAttentionModal = {show: false, onSend: () => {}}
const numberRegex = /\d+/g;

export default function AddIndexComponent() {
  const { type, id } = useParams();
  const api = useAPI();
  const addToast = useToast();
  const history = useHistory();

  const [componentOptions, setComponentOptions] = useState([]);
  const [componentData, setComponentData] = useState(defaultComponentData);
  const [formula, setFormula] = useState([]);
  const [kpiKindOptions, setKpiKindOptions] = useState([]);
  const [historyModalShow, setHistoryModalShow] = useState(false);
  const [personsHistory, setPersonsHistory] = useState([]);
  const [updateHistoryTrigger, setUpdateHistoryTrigger] = useState(false);
  const [attentionModal, setAttentionModal] = useState(defaultAttentionModal)

  const [validated, setValidated] = useState(false);
  const formEl = useRef(null);

  const handleChangeFormula = (index, value) => {
    setFormula(prevState => {
      const formula = [...prevState];
      formula[index].value = value;
      return formula;
    });
  };

  const handleChangeComponentData = (fieldName, value) => {
    setComponentData(prevState => ({
      ...prevState,
      [fieldName]: value
    }));
  };

  const handleChangeYears = (years) => {
    let plans = componentData.values;
    plans = plans.filter(yearPlan => years.includes(yearPlan.year))
    plans.push(...years
      .filter(year => plans.every(plan => plan.year !== year))
      .map(year => ({year, plan: 0, planInner: 0}))
    )
    handleChangeComponentData('values', plans)
  }

  const handleChangePlanValue = (inputValue, index, field) => {
    const valuesCopy = [...componentData.values]
    valuesCopy[index][field] = inputValue;
    handleChangeComponentData('values', valuesCopy)
  }

  const handleSave = async (event) => {
    event.preventDefault();
    event.stopPropagation();
    const form = event.currentTarget;
    if (form.checkValidity() === false || (type === 'index' && !componentData.type)) {
      const invalidEl = formEl.current.querySelector(':invalid');
      invalidEl.scrollIntoView({
        block: 'center',
        behavior: 'smooth'
      });
    } else {
      const data = {
        ...componentData,
        formula: formula.reduce((acc, curr) => {
          if (curr.type === 'component') {
            return acc + curr.value.num + ' ';
          }
          return acc + curr.value + ' ';
        }, ''),
        components: formula
          .filter(curr => curr.type === 'component')
          .map(component => component.value)
          .reduce((acc, curr) => acc.some(component => component.id === curr.id) ? acc : [...acc, curr], [])
      };
      const onSend = async () => {
        setComponentData(data)
        const response = await api.post('/kpis/0', data);
        if(response.id) {
          history.push(`/indexes/fact-part?t=${type === 'component' ? 'basic' : 'result'}`)
        }
      }
      if(data.formula.replaceAll(' ', '') !== (componentData.formula || '').replaceAll(' ', '') &&
        componentData.id){
        setAttentionModal({
          show: true,
          onSend: async () => {
            await onSend()
            setAttentionModal(defaultAttentionModal)
          }
        })
      }
      else{
        onSend()
      }
    }
    setValidated(true);
  };

  const handleDelete = async () => {
    const response = await api.del(`/kpis/${id}`)
    if(response.id){
      history.push(`/indexes/fact-part?t=${type === 'component' ? 'basic' : 'result'}`)
    }
  }

  useEffect(() => {
    const getAllFacts = async () => {
      const result = await api.get(`/kpis/0/vals?type=${factKpisType}`);
      setComponentOptions(result.map(component => ({
        label: component.num,
        value: {
          num: component.num,
          id: component.id,
          name: component.name
        }
      })));
      let suggestedIndex = '';
      result
        .map(component => +component.num.match(numberRegex)[0])
        .sort((a,b) => a - b)
        .every((a, i, arr) => {
          suggestedIndex = `П${a + 1}`
          return !(i === arr.length - 1 || arr[i + 1] - a > 1)
        })
      if(!id){
        setComponentData(prevState => ({...prevState, num: suggestedIndex}))
      }
    };
    getAllFacts();
  }, []);

  useEffect(() => {
    const getData = async () => {
      const data = await api.get(`/kpis/${id}`)
      if(data?.kpi?.formula){
        let currentElement = ''
        let formula = []
        let stringFormula = data.kpi.formula.replaceAll(' ', '')
        for (let i = 0; i < stringFormula.length; i++) {
          if('+-/*()'.includes(stringFormula[i])){
            if(currentElement.length > 0){
              let parsedComponent = parseFloat(currentElement)
              formula.push({
                type: parsedComponent || parsedComponent === 0 ? 'number' : 'component',
                value: parsedComponent || parsedComponent === 0 ? parsedComponent : data.kpi.components.find(component => component.num === currentElement)
              })
            }
            formula.push({type: 'sign', value: stringFormula[i]})
            currentElement = ''
            continue;
          }
          currentElement += stringFormula[i]
          if(i === stringFormula.length - 1){
            let parsedComponent = parseFloat(currentElement)
            formula.push({
              type: parsedComponent || parsedComponent === 0 ? 'number' : 'component',
              value: parsedComponent || parsedComponent === 0 ? parsedComponent : data.kpi.components.find(component => component.num === currentElement)
            });
          }
        }
        setFormula(formula);
      }
      setComponentData(data.kpi)
    }
    if (id){
      getData()
    }
  }, [id]);

  useEffect(() => {
    const getKpiKinds = async () => {
      const data = await api.get('/info/kpikinds');
      setKpiKindOptions((!data || data.error)
        ? []
        : data.map(d => ({ label: d.name, value: d.id })));
    }
    getKpiKinds();
  }, []);

  useEffect(() => {
    if(type === 'component'){
      setComponentData(prevState => ({
        ...prevState,
        type: 'Данные для расчета фактических значений по показателям'
      }))
    }
  }, [type]);

  useEffect(() => {
    const getHistory = async () => {
      const history = await api.get(`/kpis/${id}/userhists`)
      setPersonsHistory(history.res)
    }
    if(id){
      getHistory()
    }
  }, [id, updateHistoryTrigger]);

  const debounceRef = useRef();
  const loadEmployeesOptions = (inputValue, callback) => {
    clearTimeout(debounceRef.current);
    debounceRef.current = setTimeout(async () => {
      const employees = await api.get(`/users/employees?name=${inputValue}`);
      callback(employees.map(employee => ({
        label: `${employee.lastName} ${employee.firstName}${employee.middleName ? ' ' + employee.middleName : ''} (${employee.post})`,
        value: employee
      })));
    }, 350);
  };

  return (
    <Page className="addComponent">
      <BackBtn/>
      <h1 className="mt-3 fs-4" style={{ fontWeight: 600 }}>Добавление</h1>
      <Form onSubmit={handleSave} noValidate validated={validated} ref={formEl}>
        <Card className="mt-3" as={Card.Title}>
          <Card.Header className="py-3 px-4" style={{ fontWeight: 600 }}>
            {type === 'component' ? 'Компонент' : 'Показатель'}
          </Card.Header>
          <Card.Body>
            <div className="d-flex flex-column gap-4">
              <Row>
                <Form.Group as={Col} xs={2}>
                  <Form.Label>Номер</Form.Label>
                  <Form.Control
                    value={componentData.num}
                    onChange={(event) => handleChangeComponentData('num', event.target.value)}
                    required
                  />
                  <Form.Control.Feedback type="invalid" style={{ fontSize: 12 }}>Обязательное поле к заполнению</Form.Control.Feedback>
                </Form.Group>
                <Form.Group as={Col} xs={7}>
                  <Form.Label>Наименование показателя</Form.Label>
                  <Form.Control
                    value={componentData.name}
                    onChange={(event) => handleChangeComponentData('name', event.target.value)}
                    required
                  />
                  <Form.Control.Feedback type="invalid" style={{ fontSize: 12 }}>Обязательное поле к заполнению</Form.Control.Feedback>
                </Form.Group>
                <Form.Group as={Col} xs={3}>
                  <Form.Label>Единицы измерения</Form.Label>
                  <Select
                    placeholder=""
                    options={unitsOptions}
                    onChange={opt => handleChangeComponentData('unit', opt?.value)}
                    value={unitsOptions.find(unit => unit.value === componentData.unit)}
                    styles={selectStyles}
                  />
                </Form.Group>
              </Row>
              {type === 'index' && <Row>
                <Form.Group as={Col} xs={9}>
                  <Form.Label>Группа показателей</Form.Label>
                  <Select
                    placeholder=""
                    options={indexGroupOptions}
                    onChange={opt => handleChangeComponentData('type', opt?.value)}
                    value={indexGroupOptions.find(group => group.value === componentData.type)}
                    styles={selectStyles}
                  />
                  {validated && !componentData.type && <p className="mt-1" style={{
                    fontSize: 12,
                    color: 'crimson'
                  }}>
                    Обязательное поле к заполнению
                  </p>}
                </Form.Group>
                <Form.Group as={Col} xs={3}>
                  <Form.Label>Тип показателя</Form.Label>
                  <Select
                    placeholder=""
                    options={kpiKindOptions}
                    onChange={opt => handleChangeComponentData('kpiTypeId', opt?.value)}
                    value={kpiKindOptions.find(opt => opt.value === componentData.kpiTypeId)}
                    styles={selectStyles}
                  />
                </Form.Group>
              </Row>}
              <Row>
                <Form.Group as={Col} xs={7}>
                  <Form.Label>Срок действия</Form.Label>
                  <div className="d-flex gap-2 align-items-center" style={{ fontSize: 16 }}>
                    <Form.Control
                      type='date'
                      placeholder='Выберите дату'
                      value={componentData.startDate ? moment(componentData.startDate.split('T')[0]).format('YYYY-MM-DD') : ''}
                      onChange={(event) => handleChangeComponentData('startDate', new Date(event.target.value).toISOString())}
                    />
                    по
                    <Form.Control
                      type='date'
                      placeholder='Выберите дату'
                      value={componentData.endDate ? moment(componentData.endDate.split('T')[0]).format('YYYY-MM-DD') : ''}
                      onChange={(event) => handleChangeComponentData('endDate', new Date(event.target.value).toISOString())}
                    />
                  </div>
                </Form.Group>
              </Row>
              <Row>
                <h3 className="mb-3" style={{
                  textAlign: 'left',
                  fontSize: 18,
                  fontWeight: 600
                }}>План</h3>
                <Form.Group as={Col} xs={Math.min(4 + componentData.values.length, 12)}>
                  <Form.Label>Год</Form.Label>
                  <Select
                    noOptionsMessage={() => 'Нет доступных годов'}
                    placeholder=''
                    styles={selectStyles}
                    options={yearOptions
                      .filter(yearOpt => (!componentData.endDate || +componentData.endDate.slice(0,4) >= yearOpt.value) &&
                        (!componentData.startDate || +componentData.startDate.slice(0,4) <= yearOpt.value))}
                    value={yearOptions.filter(yearOpt => componentData.values.some(value => value.year === yearOpt.value))}
                    onChange={(yearOpts) => handleChangeYears(yearOpts.map(yearOpt => yearOpt.value))}
                    isMulti
                    isClearable
                  />
                </Form.Group>
                {componentData.values && componentData.values.length !== 0 && <>
                  <Form.Group className='mt-3' as={Col} xs={12}>
                    <Form.Label>План по Программе</Form.Label>
                    <Row>
                      {componentData.values
                        .sort((a, b) => a.year - b.year)
                        .map((value, index) => <Form.Group as={Col} xs={3}>
                        <Form.Label>{value.year} <Required/></Form.Label>
                        <Form.Control
                          type='number'
                          value={value.plan}
                          onChange={(event) => handleChangePlanValue(event.target.value, index, 'plan')}
                        />
                      </Form.Group>)}
                    </Row>
                  </Form.Group>
                  <Form.Group className='mt-3' as={Col} xs={12}>
                    <Form.Label>План максимум</Form.Label>
                    <Row>
                      {componentData.values
                        .sort((a, b) => a.year - b.year)
                        .map((value, index) => <Form.Group as={Col} xs={3}>
                        <Form.Label>{value.year} <Required/></Form.Label>
                        <Form.Control
                          type='number'
                          value={value.planInner}
                          onChange={(event) => handleChangePlanValue(event.target.value, index, 'planInner')}
                        />
                      </Form.Group>)}
                    </Row>
                  </Form.Group>
                </>}
              </Row>
              <Row>
                <Col>
                  <h3 className="mb-3" style={{
                    textAlign: 'left',
                    fontSize: 18,
                    fontWeight: 600
                  }}>Назначить ответственных <History style={{ color: "#0D6EFD", cursor: 'pointer' }} onClick={() => setHistoryModalShow(true)}/></h3>
                  <div className="addComponent-inCharge">
                    {componentData.bosses.map((boss, index) => <Row key={index}>
                      <Form.Group as={Col} xs={8}>
                        <Form.Label>{index + 1}. ФИО</Form.Label>
                        <AsyncSelect
                          noOptionsMessage={() => 'Ничего не найдено'}
                          loadingMessage={() => 'Поиск...'}
                          placeholder=""
                          defaultOptions={[]}
                          styles={selectStyles}
                          loadOptions={loadEmployeesOptions}
                          onChange={(opt) => {
                            const bosses = [...componentData.bosses];
                            bosses[index] = {
                              ...opt.value,
                              startDate: boss.startDate,
                              rowNum: boss.rowNum
                            };
                            handleChangeComponentData('bosses', bosses);
                          }}
                          value={boss.guid || boss.id || boss.employeeId ? {
                            label: `${boss.lastName} ${boss.firstName}${boss.middleName ? ' ' + boss.middleName : ''} (${boss.post})`,
                            value: boss
                          } : null}
                        />
                      </Form.Group>
                      <Form.Group as={Col} xs={3}>
                        <Form.Label>Дата назначения <Required/></Form.Label>
                        <Form.Control
                          type="date"
                          required
                          onChange={(event) => {
                            const bosses = [...componentData.bosses];
                            bosses[index] = {
                              ...boss,
                              startDate: new Date(event.target.value).toISOString()
                            };
                            handleChangeComponentData('bosses', bosses);
                          }}
                          value={boss.startDate ? moment(boss.startDate.split('T')[0]).format('YYYY-MM-DD') : ''}
                        />
                      </Form.Group>
                      <Col className='d-flex align-items-end pb-2' xs={1}>
                        <Close
                          style={{color: '#DC3545', cursor: 'pointer'}}
                          onClick={() => handleChangeComponentData(
                            'bosses',
                            componentData.bosses.filter((value, bossIndex) => bossIndex !== index)
                          )}
                        />
                      </Col>
                    </Row>)}
                    <Button
                      className="align-self-start"
                      variant="outline-primary"
                      onClick={() => handleChangeComponentData('bosses', [...componentData.bosses, { startDate: undefined }])}
                    >+ Добавить ответственного</Button>
                  </div>
                </Col>
              </Row>
              {type === 'component' && <Row>
                <Col>
                  <h3 className="mb-3" style={{
                    textAlign: 'left',
                    fontSize: 18,
                    fontWeight: 600
                  }}>
                    Назначить представителей ответственных <History style={{ color: "#0D6EFD", cursor: 'pointer' }} onClick={() => setHistoryModalShow(true)}/>
                  </h3>
                  <div className="addComponent-inCharge">
                    {componentData.delegates.map((delegate, index) => <Row key={index}>
                      <Form.Group as={Col} xs={8}>
                        <Form.Label>{index + 1}. ФИО</Form.Label>
                        <AsyncSelect
                          noOptionsMessage={() => 'Ничего не найдено'}
                          loadingMessage={() => 'Поиск...'}
                          placeholder=""
                          defaultOptions={[]}
                          styles={selectStyles}
                          loadOptions={loadEmployeesOptions}
                          onChange={(opt) => {
                            const delegates = [...componentData.delegates];
                            delegates[index] = {
                              ...opt.value,
                              startDate: delegate.startDate,
                              rowNum: delegate.rowNum
                            };
                            handleChangeComponentData('delegates', delegates);
                          }}
                          value={delegate.guid || delegate.id || delegate.employeeId ? {
                            label: `${delegate.lastName} ${delegate.firstName}${delegate.middleName ? ' ' + delegate.middleName : ''} (${delegate.post})`,
                            value: delegate
                          } : null}
                        />
                      </Form.Group>
                      <Form.Group as={Col} xs={3}>
                        <Form.Label>Дата назначения <Required/></Form.Label>
                        <Form.Control
                          type="date"
                          required
                          onChange={(event) => {
                            const delegates = [...componentData.delegates];
                            delegates[index] = {
                              ...delegate,
                              startDate: new Date(event.target.value).toISOString()
                            };
                            handleChangeComponentData('delegates', delegates);
                          }}
                          value={delegate.startDate ? moment(delegate.startDate.split('T')[0]).format('YYYY-MM-DD') : ''}
                        />
                      </Form.Group>
                      <Col className='d-flex align-items-end pb-2' xs={1}>
                        <Close
                          style={{color: '#DC3545', cursor: 'pointer'}}
                          onClick={() => handleChangeComponentData(
                            'delegates',
                            componentData.delegates.filter((value, delegateIndex) => delegateIndex !== index)
                          )}
                        />
                      </Col>
                    </Row>)}
                    <Button
                      className="align-self-start"
                      variant="outline-primary"
                      onClick={() => handleChangeComponentData('delegates', [...componentData.delegates, { startDate: undefined }])}
                    >+ Добавить представителя</Button>
                  </div>
                </Col>
              </Row>}
              <Row>
                <Form.Group as={Col} xs={12}>
                  <Form.Label>Полное наименование {type === 'component' ? 'компонента' : 'показателя'}</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={2}
                    onChange={(event) => handleChangeComponentData('fullName', event.target.value)}
                    value={componentData.fullName}
                  />
                </Form.Group>
              </Row>
              <Row>
                <Form.Group as={Col} xs={12}>
                  <Form.Label>Методика</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={4}
                    onChange={(event) => handleChangeComponentData('calcDescr', event.target.value)}
                    value={componentData.calcDescr}
                  />
                </Form.Group>
              </Row>
              <Row>
                <Col>
                  <div className="d-flex gap-2">
                    <Button
                      variant="outline-primary"
                      onClick={() => setFormula(prevState => [...prevState, {
                        type: 'component',
                        value: ''
                      }])}
                      disabled={formula.length !== 0 && formula.at(-1).type !== 'sign'}
                    >+ Компонент</Button>
                    <Button
                      variant="outline-primary"
                      onClick={() => setFormula(prevState => [...prevState, {
                        type: 'sign',
                        value: ''
                      }])}
                    >+ Знак</Button>
                    <Button
                      variant="outline-primary"
                      onClick={() => setFormula(prevState => [...prevState, {
                        type: 'number',
                        value: ''
                      }])}
                      disabled={formula.length !== 0 && formula.at(-1).type !== 'sign'}
                    >+ Число</Button>
                    <Button
                      className="addComponent-rollback d-flex align-items-center gap-2"
                      variant="outline-danger"
                      onClick={() => setFormula(prevState => {
                        const formula = [...prevState];
                        formula.pop();
                        return formula;
                      })}
                    >
                      <svg width="21" height="18" viewBox="0 0 21 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M12 0C7.03 0 3 4.03 3 9H0L3.89 12.89L3.96 13.03L8 9H5C5 5.13 8.13 2 12 2C15.87 2 19 5.13 19 9C19 12.87 15.87 16 12 16C10.4314 16 8.98175 15.4782 7.81739 14.601C7.37411 14.267 6.74104 14.259 6.3486 14.6514C5.95725 15.0428 5.95413 15.6823 6.38598 16.0284C7.92448 17.2615 9.87084 18 12 18C16.97 18 21 13.97 21 9C21 4.03 16.97 0 12 0Z" fill="#DC3545"/>
                      </svg>
                      Удалить
                    </Button>
                  </div>
                  <div className="d-flex mt-3 gap-3 align-items-center flex-wrap">
                    {formula.map((input, index) => {
                      if (input.type === 'component') {
                        return <Select
                          className="addComponent-componentControl"
                          menuPlacement="top"
                          placeholder=""
                          key={index}
                          options={componentOptions}
                          isSearchable
                          isClearable
                          styles={selectStyles}
                          onChange={(option) => handleChangeFormula(index, option?.value)}
                          value={input.value ? {
                            label: input.value.num,
                            value: input.value
                          } : null}
                        />;
                      }
                      if (input.type === 'sign') {
                        return <Form.Control
                          className="addComponent-signControl"
                          key={index}
                          value={input.value}
                          onChange={(event) => {
                            if (event.target.value.length < 2) {
                              handleChangeFormula(index, event.target.value);
                            }
                          }
                          }
                        />;
                      }
                      return <Form.Control
                        type="number"
                        className="addComponent-numberControl"
                        key={index}
                        onChange={(event) => handleChangeFormula(index, event.target.value)}
                        value={input.value}
                      />;
                    })}
                  </div>
                </Col>
              </Row>
            </div>
          </Card.Body>
        </Card>
        <Card>
          <Card.Body>
            <div className="d-flex gap-2">
              <Button
                variant="outline-secondary"
                onClick={() => {
                  history.push(`/indexes/fact-part?t=${type === 'component' ? 'basic' : 'result'}`)
                }}
              >Отменить</Button>
              <Button type="submit">Сохранить</Button>
              {(id || id === 0) && <Button variant="danger" onClick={handleDelete}>Удалить</Button>}
            </div>
          </Card.Body>
        </Card>
      </Form>
      <PersonsHistoryModal show={historyModalShow} onHide={() => setHistoryModalShow(false)} history={personsHistory}/>
      <AttentionSaveFormulaModal
        show={attentionModal.show}
        onHide={() => setAttentionModal(defaultAttentionModal)}
        onAccept={attentionModal.onSend}
      />
    </Page>
  );
};
